// File: src/App.jsx
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import HUD from "./pages/HUD/HUD";
import Admin from "./pages/Admin/Admin";
import EndGame from "./pages/EndGame/EndGame";
import Checklist from "./pages/Checklist/Checklist";
import ScoreboardPage from "./pages/Scoreboard/ScoreboardPage";
import WalkInPage from "./pages/Booking/WalkInPage";
import ExtraPlayersPage from "./pages/Booking/ExtraPlayersPage";
import FaultReportsPage from "./pages/FaultReports/FaultReportsPage";
import NewFaultReportPage from "./pages/FaultReports/NewFaultReportPage";

const App = () => (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/game/:gameId" element={<HUD />} />
        <Route path="/afslut-spil" element={<EndGame />} />
        <Route path="/checkliste" element={<Checklist />} />
        <Route path="/scoreboard" element={<ScoreboardPage />} />
        <Route path="/walk-in" element={<WalkInPage />} />
        <Route path="/ekstra-spillere" element={<ExtraPlayersPage />} />
        <Route path="/fejlmeldinger" element={<FaultReportsPage />} />
        <Route path="/fejlmeldinger/ny" element={<NewFaultReportPage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
);

export default App;